import { render, staticRenderFns } from "./InputPhoneNumber.vue?vue&type=template&id=6ffe8670&"
import script from "./InputPhoneNumber.vue?vue&type=script&lang=ts&"
export * from "./InputPhoneNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports